import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ReportTableViewSwitcherProps {
  groupBy: string;
  setGroupBy: (value: 'month' | 'week') => void;
}

function ReportTableViewSwitcher({ groupBy, setGroupBy }: ReportTableViewSwitcherProps) {
  const { t } = useTranslation();
  return (
    <>
      <button
        className={`btn btn-${
          groupBy === 'month' ? 'primary' : 'default'
        } btn-outline r-corners-left`}
        onClick={(e) => {
          setGroupBy('month');
        }}
        title={t('Group by month')}
      >
        {t('Month')}
      </button>
      <button
        className={`btn btn-${
          groupBy === 'week' ? 'primary' : 'default'
        } btn-outline r-corners-right`}
        onClick={(e) => {
          setGroupBy('week');
        }}
        title={t('Group by week')}
      >
        {t('Week')}
      </button>
    </>
  );
}

export default ReportTableViewSwitcher;
